<kendo-dialog-titlebar>
    Encounter Attendance - Absent
</kendo-dialog-titlebar>
<div class="k-d-grid k-gap-y-xl" [formGroup]="form">
    <section class="k-d-grid k-gap-y-sm">
        <div class="student-card">
            <div class="k-d-flex !k-justify-content-between">
                <div>
                    <div class="k-d-flex k-align-items-center k-gap-x-sm">
                        <fa-icon [icon]="faCircleUser" size="xl" class="k-mt-2"></fa-icon>
                        <strong>{{ studentInfo?.studentName }}</strong>
                    </div>
                    <p style="margin-left: 35px;" class="k-mt-0 k-mb-0">ID: {{ studentInfo?.studentId }}</p>
                </div>
                <div class="k-d-grid k-mt-2">
                    <p class="!k-m-0">{{ studentInfo?.mandatedDescription }}</p>
                    <p class="!k-m-0">{{ studentInfo?.mandatedLocation }}</p>
                </div>
            </div>
        </div>
        <div class="session-card ">
            <strong>Scheduled Session: {{meetingStartTime | date:'EEE MMM d h:mm a'}} ({{ studentInfo?.scheduledSessionText }})</strong>
        </div>
    </section>

    <section class="k-d-grid">
        <p class="k-mt-0">Please select the session type:</p>

        <label *ngFor="let st of sessionTypes" class="session-type-option" [ngClass]="{
      'session-type-label-error':
        form.get('sessionTypeId')?.touched &&
        form.get('sessionTypeId')?.invalid
    }">
            <input type="radio" kendoRadioButton [value]="st.id" formControlName="sessionTypeId" />
            {{ st.description }}
        </label>
        <div class="k-text-error k-text-xs k-mt-1" *ngIf="form.get('sessionTypeId')?.touched &&
             form.get('sessionTypeId')?.invalid" role="alert">
            Error: Session type is required.
        </div>
    </section>
<div class="k-form-separator"></div>
    <section class="k-mt-3">
        <h5 class="k-my-0 k-font-size-md">Attached Document(s)</h5>
        <!-- Existing documents -->
        <div class="k-mb-2 existing-documents">
            <ng-container *ngIf="hasExistingDocuments">
                <ul class="k-pl-4 k-m-0">
                    <li *ngFor="let doc of existingDocuments">
                        <div (click)="downloadDocument(doc)">
                            <a class="doc-name">
                                {{ doc.documentName }}</a>

                        </div>
                    </li>
                </ul>
            </ng-container>
            <!-- <ng-container *ngIf="selectedAttachments.length">
                <ul class="k-pl-4 k-m-0">
                    <li *ngFor="let file of selectedAttachments">
                        <a class="doc-name">{{ file.name }}</a>
                    </li>
                </ul>
            </ng-container> -->
        </div>
        <!-- New uploads -->
        <kendo-fileselect appFileRestrictions [showFileList]="true" [multiple]="true"
            (valueChange)="onFilesChange($event)">
        </kendo-fileselect>
    </section>
</div>
<kendo-dialog-actions>
    <button kendoButton themeColor="primary" (click)="onSave()">Save</button>
</kendo-dialog-actions>